import { cn } from '@/lib/utils';
import { BarChart3, ShoppingCart, MessageSquare, TrendingUp } from 'lucide-react';
import { LucideIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

interface NavItem {
  id: string;
  label: string;
  href: string;
  icon: LucideIcon;
  description?: string;
}

const navItems: NavItem[] = [
  {
    id: 'overview',
    label: 'Overview',
    href: '/analytics',
    icon: BarChart3,
    description: 'Key metrics summary',
  },
  {
    id: 'ecommerce',
    label: 'E-Commerce',
    href: '/analytics/ecommerce',
    icon: ShoppingCart,
    description: 'Sales & orders',
  },
  {
    id: 'social',
    label: 'Social',
    href: '/analytics/social',
    icon: MessageSquare,
    description: 'Engagement & AI',
  },
];

function NavLink({ item, isActive }: { item: NavItem; isActive: boolean }) {
  const Icon = item.icon;

  return (
    <Link
      to={item.href}
      className={cn(
        'flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors',
        isActive
          ? 'bg-secondary text-secondary-foreground'
          : 'text-muted-foreground hover:bg-secondary/50 hover:text-foreground'
      )}
    >
      <Icon className="h-4 w-4 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium">{item.label}</div>
        {item.description && (
          <div className="text-xs text-muted-foreground truncate">{item.description}</div>
        )}
      </div>
    </Link>
  );
}

interface AnalyticsSidebarProps {
  className?: string;
}

export function AnalyticsSidebar({ className }: AnalyticsSidebarProps) {
  const { pathname } = useLocation();

  const isActive = (href: string) => {
    if (href === '/analytics') {
      return pathname === '/analytics';
    }
    return pathname.includes(href.replace('/analytics', ''));
  };

  return (
    <div className={cn('w-56 border-r bg-background', className)}>
      <div className="p-4 space-y-1">
        {navItems.map((item) => (
          <NavLink key={item.id} item={item} isActive={isActive(item.href)} />
        ))}
      </div>
    </div>
  );
}
